import { Dispatch } from "redux";
import api from "../../api/api";
import { setEventData, resetEventData } from "../reducers/getEventOverviewByTeacherReducer";

const getEventOverviewByTeacher = (token: any, eventData: any) => async (         //if costum add these two: , start_date:any, end_date:any 
    dispatch: Dispatch
) => {


    //console.warn("getEventOverviewByTeacher", eventData);
    

    try {
        const result = await api.get(`/analytics/dashboard/teacher/get-event-overview/`, {
            params: {
                ...eventData
            },
            headers: {
                "Content-Type": "multipart/form-data",
                Authorization: `Token ${token}`,
            },
        });

        if (result) {
            dispatch(setEventData(result?.data || []))


            if (result.data?.status === 200) {
            } else {
                //dispatch(seterror(result.data?.message ?? "Something Went Wrong!"));
            }
        }
    } catch (error: any) {
        // dispatch(setloading(false));
        console.error("Error:", error);
    }
}


export { getEventOverviewByTeacher, resetEventData };

//event overview action 


